import React, {useState} from 'react';
import {useInstance} from 'react-ioc';
import {useLocation} from 'react-router';
import {Link, useNavigate} from 'react-router-dom';
import {LeftOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Form, Input} from 'antd';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {INDEX, LOGIN} from '../../config/routes';
import {Store} from '../../model/store/Store';

import {checkCode, checkCodeVariables} from './__generated__/checkCode';
import {MUTATION_CHECK_CODE} from './auth';

interface ICodeForm {
    code: string;
}

export const Code = () => {

    const [checkCode, {loading}] = useMutation<checkCode, checkCodeVariables>(MUTATION_CHECK_CODE);
    const [codeError, setCodeError] = useState<boolean>(false)
    const {state} = useLocation();
    const {auth} = useInstance(Store)
    const navigate = useNavigate()

    const onFinish = async (data: ICodeForm) => {
        await checkCode({
            variables: {
                code: data.code,
                phone: state.phone,
            },
            onCompleted: (data) => {
                if (data.checkCode.jwt) {
                    auth.setToken(data.checkCode.jwt)
                    navigate(INDEX)
                }
            },
            onError: (err) => {
                if (err.message === 'Code error') {
                    setCodeError(true)
                }
            }
        })
    }

    return (
        <Layout header={<Header title={'Код из SMS'} left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                                                   icon={<LeftOutlined/>}/>}/>}>
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'}
                  style={{textAlign: 'center', marginTop: 80}}>
                <Form.Item name={'code'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                ]}>
                    <Input.OTP type={'number'} length={4} size={'large'}/>
                </Form.Item>
                <Form.Item>
                    <Button loading={loading} htmlType={'submit'} type={'primary'} block>Далее</Button>
                </Form.Item>
                {codeError &&
                    <Form.Item>
                        <div className={'error'}>
                            Не верный код
                        </div>
                        <Link to={LOGIN}>Отправить еще раз</Link>
                    </Form.Item>
                }
            </Form>
        </Layout>

    )
}